import React, { FC } from 'react'
import styled from 'styled-components'
import { Grid } from 'semantic-ui-react'
import { LKButton as LKBaseButton, LKIcon } from 'loankeeper-common/components'
//@ts-ignore
import LKModal from 'shared/LKModal'
//@ts-ignore
import { GridContainer } from 'shared/StyledComponents'
import { translate, translateGroupAddEdit } from './helpers'
import { validatePassword } from './changePassword.utils'
import { ChangePasswordBaseProps, PasswordValidationResultProps } from './ChangePasswordForm.types'

const Wrapper = styled.div`
  .password-expired {
    color: red;
    margin-bottom: 18px;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
  }

  .align-right {
    justify-content: flex-end;
  }
`

const RuleWrapper = styled.div`
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  padding: 0 5px;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 0.28571429rem;
  width: auto;
  color: ${(props) => (props.isPassed ? '' : 'red')};
`

const Divider = styled.div`
  width: 100%;
  margin: 10px 0;
  height: 1px;
  background: lightgray;
`

const Rule: FC<{
  label: string
  isPassed: boolean
  rule: string | number
}> = ({ label, isPassed, rule }) => (
  <>
    <Grid.Column
      width={6}
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', height: '35px', padding: '5px 0' }}
    >
      <LKIcon alias={isPassed ? 'ok' : 'cancel'} style={{ width: 20, marginRight: 6 }} />
      {label}
      {' : '}
    </Grid.Column>
    <Grid.Column width={10} style={{ display: 'flex', height: '35px', padding: '5px 0 5px 5px' }}>
      <RuleWrapper isPassed={isPassed}>{rule}</RuleWrapper>
    </Grid.Column>
  </>
)

function renderRuleStatus(
  name: string,
  result: ReturnType<typeof validatePassword>,
  label: string,
  rule: string | number,
) {
  if (typeof result[name] === 'undefined') {
    return null
  }

  return <Rule label={label} isPassed={result[name]} rule={rule} />
}

const PasswordValidationResult: FC<PasswordValidationResultProps> = ({
  result,
  label,
  rules,
  passwordHistoryMessage,
  oldPasswordError,
}) => (
  <>
    <Grid.Row centered>
      {renderRuleStatus('length', result, translate('lbl_length_check'), rules.MinLength)}
      {renderRuleStatus('upper', result, label, 'ABCD...')}
      {renderRuleStatus('lower', result, label, 'abcd...')}
      {renderRuleStatus('numbers', result, label, '123...')}
      {renderRuleStatus('special1', result, label, rules.SpecialChars1)}
      {renderRuleStatus('special2', result, label, rules.SpecialChars2)}
    </Grid.Row>

    {rules.PassHistoryCount > 0 && (
      <Grid.Row centered style={{ marginTop: 18, color: 'red', fontWeight: 'bold' }}>
        <Grid.Column width={10} style={{ textAlign: 'left' }}>
          {passwordHistoryMessage}
        </Grid.Column>
      </Grid.Row>
    )}

    {oldPasswordError && (
      <Grid.Row centered style={{ marginTop: 18, color: 'red', fontWeight: 'bold' }}>
        <Grid.Column width={10} style={{ textAlign: 'left' }}>
          {oldPasswordError}
        </Grid.Column>
      </Grid.Row>
    )}
  </>
)

export class ChangePasswordBase extends React.Component<ChangePasswordBaseProps> {
  skipping = false

  handleClose = () => {
    this.props.closeModal()

    if (!this.skipping && this.props.lockOnClose) {
      this.props.lock()
    }
  }

  handleSkip = () => {
    this.skipping = true
    this.props.closeModal()
  }

  render() {
    const { modalName, form, username, rules, allowSkip, fields, onSubmit, oldPasswordError, passwordExpired } =
      this.props

    const { submitting, invalid } = form

    const passwordValidationResult = validatePassword(form.values.newPassword, rules)

    return (
      <LKModal
        icon="key2"
        name={modalName}
        heading={translate('frm_Sec_pass_change')}
        onClose={this.handleClose}
        size="sm-1"
        autoHeight={true}
        footer={
          <LKModal.Footer>
            <LKBaseButton.Okay onClick={onSubmit} loading={submitting} disabled={submitting || invalid} />
            <LKModal.CancelButton disabled={submitting} text={translate('cmd_cancel')} />
            {allowSkip && (
              <LKBaseButton alias="clock" onClick={this.handleSkip} disabled={submitting}>
                {translate('cmd_later')}
              </LKBaseButton>
            )}
          </LKModal.Footer>
        }
      >
        <Wrapper>
          <GridContainer>
            <Grid>
              {passwordExpired && (
                <Grid.Row className="password-expired">
                  <Grid.Column width={16}>თქვენს პაროლს ვადა გაუვიდა, გთხოვთ შეცვალოთ ახლით!</Grid.Column>
                </Grid.Row>
              )}

              <Grid.Row style={{ minHeight: '33px' }}>
                <Grid.Column width={6} className="u-flex u-alignCenter align-right">
                  {translate('lbl_user')}
                  {' : '}
                </Grid.Column>
                <Grid.Column width={10} className="u-flex u-alignCenter">{`"${username}"`}</Grid.Column>
              </Grid.Row>

              {fields}

              <Divider />

              <PasswordValidationResult
                result={passwordValidationResult}
                rules={rules}
                label={translate('lbl_use')}
                passwordHistoryMessage={translateGroupAddEdit('lbl_pass_history')}
                oldPasswordError={oldPasswordError}
              />
            </Grid>
          </GridContainer>
        </Wrapper>
      </LKModal>
    )
  }
}
